import { Box, Button, Modal, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import FillLabelTxtField from '../../../components/FillLabelTxtField';
import ScrollBox from '../../../components/ScrollBox';
import { datePickerformat } from '../../../utils/format';

function FilterMdl({ modalOpen, handleModalClose, filterObj, handleFilterObj }) {
    const [formErrors, setFormErrors] = useState({});
    const { t } = useTranslation();

    let txtFieldProps = { fontSize: 14, height: 38, width: 250 };

    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData);
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);

        if (Object.keys(errorsObj).length > 0)
            return;

        handleFilterObj(inputObject);
        handleModalClose();
    }

    const clearFormFields = () => {
        handleFilterObj({
            fromDate: '',
            toDate: ''
        });
        handleModalClose();
        setFormErrors({});
    };

    return (
        <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <form onSubmit={handleSubmit} >
                <Box sx={modalStyle}>
                    <Stack direction={'row'} alignItems={"center"} mb={3}>
                        <Typography sx={{ fontWeight: "bold", fontSize: 17, color: "rgba(0, 0, 0, 0.6)", mr: 1 }}>History Filter</Typography>
                    </Stack>
                    <ScrollBox height={"80%"}>
                        <Stack gap={2} alignItems="center">
                            <Stack direction={"row"} gap={3} mb={1}>
                                <FillLabelTxtField defaultValue={datePickerformat(filterObj.fromDate)} type={"date"} name="fromDate" title={t("bo.filterMdl.fromDate")} errMsg={formErrors.fromDate} {...txtFieldProps} />
                                <FillLabelTxtField defaultValue={datePickerformat(filterObj.toDate)} type={"date"} name="toDate" title={t("bo.filterMdl.toDate")} errMsg={formErrors.toDate} {...txtFieldProps} />
                            </Stack>
                        </Stack>
                    </ScrollBox>
                    <Stack direction={"row"} justifyContent={"space-between"} sx={{ mt: 2, mb: 2 }}>
                        <Button variant="outlined" onClick={clearFormFields} sx={{ height: 40, width: 150 }}>{t("bo.filterMdl.clear")}</Button>
                        <Stack justifyContent={"flex-end"} direction={"row"} width={500}>
                            <Button variant="text" sx={{ height: 40, width: 120 }} onClick={handleModalClose}>{t("bo.filterMdl.cancel")}</Button>
                            <Button variant="contained" type='submit' sx={{ height: 40, width: 150 }}>{t("bo.filterMdl.save")}</Button>
                        </Stack>
                    </Stack>
                </Box>
            </form>
        </Modal>
    )
}

export default FilterMdl;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 590,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 3,
    py: 2,
    borderRadius: 2,
    height: "auto",
    maxHeight: "90%"
};

function validate(values) {
    const errors = {};

    if (!values.fromDate)
        errors.fromDate = "From Date is required!";

    if (!values.toDate)
        errors.toDate = "To Date is required!";

    return errors;
};
